export const TEST_ID = 'minusIcon';
